/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { classnames } from "@culturehq/components";
import PromptIcon from "components/stories/PromptIcon";
import PromptShareOptions from "components/stories/PromptShareOptions";
import { useIsLoggedIn, useIsMobile } from "app/hooks";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const PostStoryPromptSelection = () => {
  const isLoggedIn = useIsLoggedIn();
  const isMobile = useIsMobile();
  const {
    organization,
    isCrossTenant,
    state: { selectedPrompt, selectedQuestion }
  } = usePostStoryContext();

  return (
    <div
      className={classnames("Shares-Column", { "public-user": !isLoggedIn })}
    >
      {!isMobile && <PromptIcon allowedTypes={selectedPrompt?.allowedTypes} />}
      {isLoggedIn && selectedPrompt && !selectedQuestion && !isCrossTenant && (
        <PromptShareOptions
          organization={organization}
          storyQuestion={selectedPrompt}
          parentPromptId={selectedPrompt?.parentStoryQuestion?.id}
        />
      )}
    </div>
  );
};

export default PostStoryPromptSelection;
